import { takeLatest, put, delay, call } from 'redux-saga/effects';
import * as TYPES from '../actions/types';
import { getUnreadMessageCount, saveMessagesList, saveUnreadMessageCount, setMessageLoading } from '../actions';
import { GenericResponseModel } from '../../dataModel/authModels';
import { messages } from '../../services/messageService';

export function* getMessageListSaga() {
    try {
      yield takeLatest(TYPES.GET_MESSAGES, getMessageListWorker);
    } catch (err) {
    }
  }
  
  function* getMessageListWorker(param:any) {
    try {
      yield put(setMessageLoading(true));
      const response: GenericResponseModel = yield messages.getMessageList(param['payload']);
      if(response && response.resultData){
      yield put(saveMessagesList(response));  
      }
      yield put(setMessageLoading(false));
    }catch(e){
    }
  }


  export function* getUnreadMessageCountSaga() {
    try {
      yield takeLatest(TYPES.GET_UNREAD_MESSAGES, unreadMessageCounter);
    } catch (err) {
    }
  }
  
  function* unreadMessageCounter(param:any) {
    try {
      const response: GenericResponseModel = yield messages.getUnreadMessageCount();
      if(response && response.resultData){
      yield put(saveUnreadMessageCount(response.resultData));  
      
      }else{
        yield put(saveUnreadMessageCount(0));  
      }
    }catch(e){
    }
  }


  export function* markMessagesReadSaga() {
    try {
      yield takeLatest(TYPES.MARK_MESSAGE_READ, markMessageReadWorker);
    } catch (err) {
    }
  }
  
  function* markMessageReadWorker(param:any) {
    try {
      const response: GenericResponseModel = yield messages.markMessageRead(param['payload']);
      if(response && response.resultData){
      yield put(getUnreadMessageCount());  
      }
    }catch(e){
    }
  }